import { render, staticRenderFns } from "./FilterCard.vue?vue&type=template&id=2197b10d&scoped=true&"
import script from "./FilterCard.vue?vue&type=script&lang=ts&"
export * from "./FilterCard.vue?vue&type=script&lang=ts&"
import style0 from "./FilterCard.vue?vue&type=style&index=0&id=2197b10d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2197b10d",
  null
  
)

export default component.exports